export default __webpack_public_path__ + "static/carafe-b129330ce9bd46d7835b3014e36fd834.jpg";